/* eslint-disable @typescript-eslint/no-explicit-any */
import { Theme } from '@mui/material';
import { GridEventListener } from '@mui/x-data-grid-premium';

interface DataGridStylesProps {
 onRowClick?: GridEventListener<'rowClick'> | undefined;
 onCellClick?: GridEventListener<'cellClick'> | undefined;
 sx?: Array<any> | object;
}

const dataGridStyles = (props?: Theme) =>
 //  console.log(props?.palette.mode, props?.palette);
 ({
  //  ...props?.sx,
  '--DataGrid-containerBackground': `${props?.palette.kemek.white}`,
  '& .MuiDataGrid-root': {
   borderRadius: 0,
   border: 'none',
   borderColor: props?.palette.kemek.lightestGray,
  },
  '& .MuiDataGrid-main': {
   background: props?.palette.kemek.white,
  },
  '& .MuiDataGrid-root-densityCompact': {
   '& .MuiDataGrid-cell': {
    display: 'flex',
   },
  },
  '& .MuiDataGrid-topContainer': {
   zIndex: 5,
  },
  '& .MuiDataGrid-container--top[role=row]': {
   background: 'red',
  },
  '& .MuiDataGrid-columnHeaders': {
   borderRadius: 0,
   borderTop: '1px solid',
   borderColor: props?.palette.kemek.lightestGray,
   background: '#D6ECF8',
   // minHeight: '34px !important',
   // maxHeight: '34px !important',
   // lineHeight: '34px !important',
  },
  '& .MuiDataGrid-columnHeader': {
   padding: ' 0 12px',
   '& .MuiBadge-badge': {
    background: props?.palette.kemek.blue,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px',
    height: '20px',
    lineHeight: '18px',
    color: 'white',
    fontSize: 10,
    fontWeight: 500,
    padding: 0,
    borderRadius: '50%',
    transform: 'translate(15%, -15%)',
   },
   // height: '34px !important',
  },
  '& .MuiDataGrid-headerFilterRow': {
   '& .model-header': {
    pt: '8px !important',
   },
  },
  '& .MuiDataGrid-virtualScroller': {
   // marginTop: '34px !important',
  },
  '& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator': {
   //   display: 'none',
  },
  '& .MuiDataGrid-columnHeadersInners': {
   background: 'red',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
   fontSize: 14,
   //   whiteSpace: 'break-spaces',
   //   lineHeight: 'initial',
   //   overflow: 'hidden',
   //   textOverflow: 'ellipsis',
   //   display: '-webkit-box',
   //   WebkitLineClamp: '2',
   //   WebkitBoxOrient: 'vertical',
  },
  '& .MuiDataGrid-columnSeparator': {
   //   minHeight: '30px !important',
   //   color: 'white',
  },
  '& .MuiDataGrid-columnHeader--moving': {
   //   backgroundColor: 'transparent',
  },
  '& .MuiDataGrid-row': {
   '&.isEnabled-false': {
    background: props?.palette.kemek.bg2,
    '&:hover': {
     background: props?.palette.kemek.bg2,
    },
   },
   //   cursor: !!props?.onRowClick || !!props?.onCellClick ? 'pointer' : 'initial',
   '&:hover': {
    background: 'rgba(96, 128, 255, 0.08)',
   },
   '&.odd': {
    background: 'red',
    '&:hover': {
     background: 'rgba(96, 128, 255, 0.08)',
    },
    '&.Mui-selected': {
     background: 'rgba(96, 128, 255, 0.08)',
     '&:hover': {
      background: 'rgba(96, 128, 255, 0.16)',
     },
    },
    '&.row-sidebar': {
     background: 'rgba(96, 128, 255, 0.16)',
     '&:hover': {
      background: 'rgba(96, 128, 255, 0.16)',
     },
    },
   },
   '&.row-sidebar': {
    background: 'rgba(96, 128, 255, 0.16)',
    '&:hover': {
     background: 'rgba(96, 128, 255, 0.16)',
    },
   },
  },
  '& .MuiDataGrid-pinnedRows': {
   '& .MuiDataGrid-row': {
    '&:hover': {
     background: 'white',
    },
    '& .limit-span': {
     background: props?.palette.kemek.darkestGray,
     color: 'white',
    },
   },
  },
  '& .MuiDataGrid-cell': {
   display: 'flex',
   alignItems: 'center',
   fontSize: 14,
   lineHeight: '25px',
   whiteSpace: 'normal !important',
   wordWrap: 'break-word !important',
   //   whiteSpace: 'break-spaces',
   padding: { xs: '8px', md: '12px' },
   //   overflow: 'hidden',
   textOverflow: 'initial',
   //   padding: 1,

   '&.MuiDataGrid-cell--editing': {
    //   padding: '4px',
   },
   '&:focus-within': {
    outline: 'none !important',
   },
  },
  '& .MuiDataGrid-detailPanel.MuiBox-root': {
   padding: 0,
   background: 'transparent',

   '& >div': {
    padding: '0 8px',
   },
  },
  '& .MuiDataGrid-columnHeader.model-header': {
   alignItems: 'flex-start',
  },
  '.MuiCheckbox-root': {
   padding: '0px',
   color:
    props?.palette.mode === 'dark' ? props?.palette.kemek.gray : 'inherit',
   //    '&.Mui-checked': {
   //     // color: props?.palette.kemek.gray,
   //    },
  },
  '& .MuiPaginationItem-root': {
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
   minWidth: 32,
   height: 32,
   border: `1px solid ${props?.palette.kemek.lightGray}`,
   '&.Mui-selected': {
    color: props?.palette.kemek.blue,
    borderColor: props?.palette.kemek.blue,
    background: 'transparent',
   },
  },
  '& .MuiPaginationItem-page': {
   fontSize: 12,
   //   color: '#686868',
   display: { xs: 'none', md: 'block' },
  },
  '& .MuiTablePagination-input': {
   display: { xs: 'inline-flex', md: 'inline-flex' },
  },
  // tricky, hides block on the right when no rows displayed
  '& .MuiDataGrid-filler--pinnedRight': {
   display: 'none',
  },
 });
export default dataGridStyles;
